import { FormField, FormItem, FormLabel, FormControl, FormMessage } from '../ui/form';
import { Control } from 'react-hook-form';
import { useGetInstitutionListsQuery } from '../../app/services/selectListService';
import { Select, MenuItem, FormControl as MuiFormControl } from '@mui/material';

interface InstitutionSelectorProps {
  control: Control<any>;
  name: string;
  label?: string;
  placeholder?: string;
  allowAll?: boolean;
}

function InstitutionSelector({ 
  control, 
  name, 
  label = "Institution",
}: InstitutionSelectorProps) {
  const { data: institutionsData, isLoading } = useGetInstitutionListsQuery();
  const institutions = institutionsData?.data || [];

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {label}
          </FormLabel>
          <FormControl>
            <MuiFormControl fullWidth size="small">
              <Select
                value={field.value?.toString() || ''}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === 'all' || value === '') {
                    field.onChange(undefined);
                  } else {
                    field.onChange(parseInt(value));
                  }
                }}
                disabled={isLoading}
                displayEmpty
                sx={{
                  height: '44px',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'divider',
                  },
                  '&:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                  },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'primary.main',
                    borderWidth: '2px',
                  },
                }}
              >
                <MenuItem value="" disabled>
                  Select Institution
                </MenuItem>
                {institutions.map((institution) => (
                  <MenuItem key={institution.id} value={institution.id.toString()}>
                    {institution.name}
                  </MenuItem>
                ))}
              </Select>
            </MuiFormControl>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

export default InstitutionSelector;